import React from "react";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin as faLinkedinIcon } from '@fortawesome/free-brands-svg-icons';
import { CONTACT } from '../siteConfig.js';

function ContactUs() {

    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitted(true);
        setTimeout(() => setSubmitted(false), 3000);
    };

    return(
        <div className="bg-dj-dark py-12 md:py-28 px-4 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Content Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
                    {/* Contact Info - Left Column with Header */}
                    <div className="space-y-8">
                        {/* Section Header */}
                        <div id="contact" className="scroll-mt-32">
                            <h2 className="text-sm font-semibold uppercase tracking-widest text-secondary mb-4">Get In Touch</h2>
                            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">Let's Work Together</h1>
                            <p className="text-gray-400 text-lg md:text-xl mb-8">I'm always interested in hearing about new projects and opportunities.</p>
                        </div>

                        <div>
                            <h3 className="text-2xl font-bold text-white mb-4">Let's Connect</h3>
                            <p className="text-gray-400 leading-relaxed mb-8">
                                Have a project in mind? Want to discuss design strategy? I'd love to hear from you. Reach out directly or connect with me on LinkedIn.
                            </p>
                        </div>

                        {/* Contact Options */}
                        <div className="space-y-4">
                            {/* Email */}
                            <a href={`mailto:${CONTACT.email}`} className="flex items-center group cursor-pointer">
                                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary transition-colors mr-4">
                                    <FontAwesomeIcon icon={faEnvelope} className="text-primary group-hover:text-white text-lg transition-colors" />
                                </div>
                                <div>
                                    <p className="text-white font-semibold group-hover:text-primary transition-colors">Email Me</p>
                                    <p className="text-gray-400 text-sm">{CONTACT.email}</p>
                                </div>
                            </a>

                            {/* LinkedIn */}
                            <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center group cursor-pointer">
                                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary transition-colors mr-4">
                                    <FontAwesomeIcon icon={faLinkedinIcon} className="text-primary group-hover:text-white text-lg transition-colors" />
                                </div>
                                <div>
                                    <p className="text-white font-semibold group-hover:text-primary transition-colors">Connect on LinkedIn</p>
                                    <p className="text-gray-400 text-sm">Let's network and share ideas</p>
                                </div>
                            </a>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="bg-dj-light rounded-lg p-6 md:p-8">
                        <form className="space-y-4 w-full" name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit}>
                            <input type="hidden" name="form-name" value="contact" />
                            
                            <div>
                                <label className="block text-dj-dark font-semibold text-sm mb-2" htmlFor="name">
                                    Your Name
                                </label>
                                <input 
                                    className="w-full px-3 py-2 rounded bg-white text-dj-dark placeholder-gray-400 border border-gray-300 focus:border-primary focus:outline-none transition-colors" 
                                    id="name" 
                                    type="text" 
                                    name="name"
                                    placeholder="Derek Johnston" 
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-dj-dark font-semibold text-sm mb-2" htmlFor="email">
                                    Your Email
                                </label>
                                <input 
                                    className="w-full px-3 py-2 rounded bg-white text-dj-dark placeholder-gray-400 border border-gray-300 focus:border-primary focus:outline-none transition-colors" 
                                    id="email" 
                                    type="email" 
                                    name="email" 
                                    placeholder="your@email.com"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-dj-dark font-semibold text-sm mb-2" htmlFor="message">
                                    Message
                                </label>
                                <textarea 
                                    className="w-full px-3 py-2 rounded bg-white text-dj-dark placeholder-gray-400 border border-gray-300 focus:border-primary focus:outline-none transition-colors resize-none h-24" 
                                    id="message" 
                                    name="message"
                                    placeholder="Tell me about your project..." 
                                    required
                                />
                            </div>

                            <input type="text" name="bot-field" style={{ display: 'none' }} />
                            
                            <button 
                                className="w-full bg-primary hover:bg-secondary text-dj-dark font-bold py-3 px-6 rounded transition-colors flex items-center justify-center gap-2" 
                                type="submit"
                            >
                                {submitted ? '✓ Message Sent!' : 'Send Message'} <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;